import React from "react";
import { Building2, Users, Clock, Euro, PlaneTakeoff, Hotel, Network, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { NETWORK_MODES, eur, hours } from "@/components/etablissement/shared";

export function SiteOverviewBar({ totals, entreprise, onMode, onSeasonal }) {
  const cells = [
    { icon: Building2, label: "Établissements", value: totals.nb_sites, sub: `${totals.nb_sites_actifs} actifs`, testid: "ov-sites" },
    { icon: Users, label: "Salariés affectés", value: `${totals.nb_affectes}/${totals.nb_salaries}`, sub: totals.nb_non_affectes ? `${totals.nb_non_affectes} à affecter` : "tous affectés", testid: "ov-salaries", warn: totals.nb_non_affectes > 0 },
    { icon: Clock, label: "Heures planifiées", value: hours(totals.heures_mois), sub: "ce mois, tous sites", testid: "ov-heures" },
    { icon: Euro, label: "CA consolidé", value: eur(totals.ca_mois), sub: `dont siège ${eur(totals.ca_siege_mois)}`, testid: "ov-ca", highlight: true },
    { icon: PlaneTakeoff, label: "Congés en attente", value: totals.conges_pending, sub: "toute l'entreprise", testid: "ov-conges", warn: totals.conges_pending > 0 },
    { icon: Hotel, label: "Réservations", value: totals.reservations_mois, sub: "ce mois", testid: "ov-resa" },
  ];
  const mode = NETWORK_MODES[entreprise.network_mode] || NETWORK_MODES.multi;
  return (
    <div className="space-y-4" data-testid="site-overview-bar">
      <div className="grid grid-cols-2 lg:grid-cols-6 border border-[#0A0A0A] bg-white">
        {cells.map((c) => (
          <div key={c.testid} data-testid={c.testid}
               className={`p-4 lg:p-5 border-r border-b lg:border-b-0 border-[#0A0A0A] last:border-r-0 ${c.highlight ? "bg-[#002FA7] text-white" : c.warn ? "bg-[#FFFBEB]" : ""}`}>
            <div className="flex items-center gap-2">
              <c.icon className={`h-3 w-3 ${c.highlight ? "text-[#FFD700]" : "text-[#002FA7]"}`} />
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-70">{c.label}</div>
            </div>
            <div className="font-display text-2xl lg:text-3xl font-black tracking-tighter mt-1">{c.value}</div>
            <div className={`text-[10px] mt-0.5 ${c.highlight ? "text-white/70" : "text-[#868E96]"}`}>{c.sub}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-white border border-[#DEE2E6] p-4 flex items-start gap-4" data-testid="ov-network-mode">
          <Network className="h-5 w-5 text-[#002FA7] mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96]">Mode réseau</div>
            <div className="flex gap-1 mt-2">
              {Object.entries(NETWORK_MODES).map(([k, m]) => (
                <button key={k} onClick={() => onMode(k)} data-testid={`ov-mode-${k}`}
                        className={`h-9 px-3 text-xs font-bold uppercase tracking-wider border transition-colors ${entreprise.network_mode === k ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-[#DEE2E6] hover:border-[#0A0A0A]"}`}>
                  {m.short}
                </button>
              ))}
            </div>
            <p className="text-xs text-[#495057] mt-2" data-testid="ov-mode-desc">{mode.desc}</p>
          </div>
        </div>
        <div className="bg-white border border-[#DEE2E6] p-4 flex items-start gap-4" data-testid="ov-seasonal">
          <Sun className="h-5 w-5 text-[#FFD700] mt-0.5 shrink-0" />
          <div className="flex-1">
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96]">Mode saisonnier</div>
                <div className="font-semibold text-sm mt-1">{entreprise.seasonal_mode ? "Activé" : "Désactivé"}</div>
              </div>
              <Switch checked={!!entreprise.seasonal_mode} onCheckedChange={onSeasonal} data-testid="ov-seasonal-switch" />
            </div>
            <p className="text-xs text-[#495057] mt-2">Périodes d'ouverture par établissement, statut ouvert/fermé du jour, salariés saisonniers et statistiques par saison (campings, loisirs, événementiel, hébergement).</p>
          </div>
        </div>
      </div>
    </div>
  );
}
